// First page of this visit. Kept for the tab so a later login still has it.
const KEY = 'repatchAttribution';

function cleanPath(value) {
  if (!value || typeof value !== 'string') return '';
  const path = value.split('?')[0].split('#')[0];
  if (!path.startsWith('/') || path.startsWith('//') || path.length > 255) return '';
  if (!/^\/[a-zA-Z0-9/_\-.%]*$/.test(path)) return '';
  return path;
}

function cleanReferrer(value) {
  if (!value || typeof value !== 'string') return '';
  try {
    const ref = new URL(value);
    if (ref.protocol !== 'https:') return '';
    const next = ref.origin + ref.pathname + ref.search;
    return next.length > 512 ? next.slice(0, 512) : next;
  } catch {
    return '';
  }
}

export function captureAttribution() {
  if (typeof window === 'undefined') return;
  try {
    if (window.sessionStorage.getItem(KEY)) return;
    const params = new URLSearchParams(window.location.search);
    const landingPage = cleanPath(params.get('from')) || cleanPath(window.location.pathname) || '/';
    const referrer = cleanReferrer(document.referrer);
    window.sessionStorage.setItem(KEY, JSON.stringify({ landingPage, referrer }));
  } catch {
    // Private mode can block sessionStorage. The ticket is still created.
  }
}

export function getAttribution() {
  try {
    const raw = JSON.parse(window.sessionStorage.getItem(KEY) || '{}');
    return {
      landingPage: cleanPath(raw.landingPage),
      referrer: cleanReferrer(raw.referrer),
    };
  } catch {
    return { landingPage: '', referrer: '' };
  }
}

captureAttribution();
